import { useEffect, useRef } from 'react'
import styled from 'styled-components'

export const ProductDisplay = ({
  items,
  current,
  itemId,
  isMobile = false,
}: {
  items: Item[]
  current: number
  itemId: number
  isMobile?: boolean
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    containerRef.current?.scrollTo({
      left: current * (isMobile ? 239 : 290),
      behavior: 'smooth',
    })
  }, [current])

  return (
    <ProductDisplayRoot>
      <ImageContainer ref={containerRef}>
        <Wrapper>
          {items.map((item) => {
            return (
              <img src={require(`../../images/Products/${item.image}.png`)} />
            )
          })}
        </Wrapper>
      </ImageContainer>
      <Count>
        <b>{itemId}</b> von {items.length}
      </Count>
    </ProductDisplayRoot>
  )
}

const ProductDisplayRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: 300px;
  position: relative;
  background-image: url(${require('../../images/product_display_bg_prod.png')});
  background-size: contain;
  margin-bottom: 15px;
  img {
    max-width: 200px;
  }
  @media screen and (max-width: 711px) {
    width: 200px;
    height: 200px;
    img {
      max-width: 150px;
    }
  }
`
const Count = styled.div`
  position: absolute;
  bottom: 10px;
  font-size: 16px;
  color:#fff;

  b {
    font-size: 18px;
  }
  @media screen and (max-width: 711px) {
    bottom: 1px;
  }
`
const ImageContainer = styled.div`
  display: flex;
  align-items: center;

  width: 300px;
  height: 300px;
  position: absolute;
  top: 0;
  left: 3px;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 150px;
    height: 150px;
    ;
  }
  @media screen and (max-width: 711px) {
    width: 200px;
    height: 200px;
    img {
    width: 100px;
    height: 100px;
    ;
  }
  }
`

const Wrapper = styled.div`
  display: flex;
  gap: 140px;
  padding-left: 75px;
  padding-right: 75px;

  @media screen and (max-width: 711px) {
    padding-left: 40px;
    padding-right: 40px;
  }
`
